export const pageListArray = [
  {
    value: "lockers",
    name: "Lockers",
    group: "lockers",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerFees",
    name: "Locker Fees",
    group: "lockers",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerStorageFees",
    name: "Locker Storage Fees",
    group: "lockers",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "assignToBranch",
    name: "Assign to Branch",
    group: "lockers",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "assignToAgent",
    name: "Assign to Agent",
    group: "lockers",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerCleanUp",
    name: "Locker Clean Up",
    group: "lockers",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  // {
  // 	value: "reassignPackages",
  // 	name: "Reassign Packages",
  // 	group: "lockers",
  // 	permissions: [
  // 		{ id: "0", text: "No Access", checked: false },
  // 		{ id: "1", text: "Read Only", checked: false },
  // 		{ id: "2", text: "Read and Write", checked: false },
  // 	],
  // },
  {
    value: "lockerUserAccounts",
    name: "Locker User Accounts",
    group: "locker-users",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerUserType",
    name: "Locker User Type",
    group: "locker-users",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "viewPackageHistory",
    name: "View Package History",
    group: "locker-users",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "broadcastUser",
    name: "Broadcast User",
    group: "locker-users",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "agents",
    name: "Agents",
    group: "agents",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "batchUpload",
    name: "Batch Upload",
    group: "agents",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "broadcastAgents",
    name: "Broadcast Agents",
    group: "agents",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "partners",
    name: "Partners",
    group: "partners",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "partnerTypes",
    name: "Partner Types",
    group: "partners",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "branches",
    name: "Branches",
    group: "partners",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "paymentModeAndFees",
    name: "Payment Mode and Fees",
    group: "partners",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerTimeLimits",
    name: "Locker Time Limits",
    group: "settings",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "storageTimeLimits",
    name: "Storage Time Limits",
    group: "settings",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerUserTemplates",
    name: "Locker User Templates",
    group: "settings",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "courierTemplates",
    name: "Courier Templates",
    group: "settings",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerCleanupTemplates",
    name: "Locker Cleanup Templates",
    group: "settings",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "walletTopUp",
    name: "Wallet Top Up",
    group: "settings",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "behavioralCampaign",
    name: "Behavioral Campaign",
    group: "campaigns",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  // {
  // 	value: "redemptionCode",
  // 	name: "Redemption Code Campaign",
  // 	group: "campaigns",
  // 	permissions: [
  // 		{ id: "0", text: "No Access", checked: false },
  // 		{ id: "1", text: "Read Only", checked: false },
  // 		{ id: "2", text: "Read and Write", checked: false },
  // 	],
  // },
  // {
  // 	value: "suspiciousCourier",
  // 	name: "Suspicious Courier",
  // 	group: "reports",
  // 	permissions: [
  // 		{ id: "0", text: "No Access", checked: false },
  // 		{ id: "1", text: "Read Only", checked: false },
  // 		{ id: "2", text: "Read and Write", checked: false },
  // 	],
  // },
  // {
  // 	value: "unrecognizedWaybill",
  // 	name: "Unrecognize Waybill",
  // 	group: "reports",
  // 	permissions: [
  // 		{ id: "0", text: "No Access", checked: false },
  // 		{ id: "1", text: "Read Only", checked: false },
  // 		{ id: "2", text: "Read and Write", checked: false },
  // 	],
  // },
  // {
  // 	value: "lockerOccupancy",
  // 	name: "Locker Occupancy",
  // 	group: "reports",
  // 	permissions: [
  // 		{ id: "0", text: "No Access", checked: false },
  // 		{ id: "1", text: "Read Only", checked: false },
  // 		{ id: "2", text: "Read and Write", checked: false },
  // 	],
  // },
  // {
  // 	value: "lockerFullAlerts",
  // 	name: "Locker Full Alerts",
  // 	group: "reports",
  // 	permissions: [
  // 		{ id: "0", text: "No Access", checked: false },
  // 		{ id: "1", text: "Read Only", checked: false },
  // 		{ id: "2", text: "Read and Write", checked: false },
  // 	],
  // },
  {
    value: "dropoffStatusHistory",
    name: "Dropoff Status History",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerOccupancy",
    name: "Locker Occupancy",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerFullAlerts",
    name: "Locker Full Alerts",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerOccupancyPeakHoursReport",
    name: "Locker Occupancy Peak Hours Report",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "packageDropoffPeakHoursReport",
    name: "Package Dropoff Peak Hours Report",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "staytimeInLocker",
    name: "Staytime in Locker",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "partnerPerformance",
    name: "Partner Performance",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "podReports",
    name: "Payment on Delivery",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "podSummaryReport",
    name: "Payment On Delivery Summary Report",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  // {
  // 	value: "lockerRentals",
  // 	name: "Locker Rental Fees",
  // 	group: "reports",
  // 	permissions: [
  // 		{ id: "0", text: "No Access", checked: false },
  // 		{ id: "1", text: "Read Only", checked: false },
  // 		{ id: "2", text: "Read and Write", checked: false },
  // 	],
  // },
  {
    value: "storageRentals",
    name: "Storage Rental Fees",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "storageFeesSummaryReport",
    name: "Storage Rental Fees Summary Report",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "overstayFees",
    name: "Overstay Fees",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "overstayFeesReportSummary",
    name: "Overstay Fees Summary Report",
    group: "reports",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "suspiciousCourierOPReport",
    name: "Suspicious Courier",
    group: "operations-report",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "highRemovalCouriers",
    name: "High Removal Couriers",
    group: "operations-report",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "suspiciousCourierTagging",
    name: "Suspicious Courier Tagging",
    group: "operations-report",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "unrecognizedWaybillOPReport",
    name: "Unrecognized Waybill",
    group: "operations-report",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "decliningUsageReport",
    name: "Declining Usage Finder",
    group: "operations-report",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "lockerClearingSummary",
    name: "Locker Clearing Summary",
    group: "operations-report",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },

  {
    value: "collectionSummary",
    name: "Collection Summary",
    group: "accounting",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "refundRequests",
    name: "Refund Request",
    group: "accounting",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },

  {
    value: "operatorAccounts",
    name: "Operator Accounts",
    group: "manage-operator-account",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
  {
    value: "rolesAndTemplates",
    name: "Roles and Templates",
    group: "manage-operator-account",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },

  {
    value: "accessPermission",
    name: "Access Permission",
    group: "manage-operator-account",
    permissions: [
      { id: "0", text: "No Access", checked: false },
      { id: "1", text: "Read Only", checked: false },
      { id: "2", text: "Read and Write", checked: false },
    ],
  },
];
export const noPermissionRole = {
  operatorAccounts: "0",
  rolesAndTemplates: "0",
  accessPermission: "0",
  lockers: "0",
  lockerFees: "0",
  lockerStorageFees: "0",
  assignToBranch: "0",
  assignToAgent: "0",
  lockerCleanUp: "0",
  reassignPackages: "0",
  lockerUserAccounts: "0",
  lockerUserType: "0",
  viewPackageHistory: "0",
  broadcastUser: "0",
  agents: "0",
  batchUpload: "0",
  broadcastAgents: "0",
  partners: "0",
  partnerTypes: "0",
  branches: "0",
  paymentModeAndFees: "0",
  lockerTimeLimits: "0",
  storageTimeLimits: "0",
  lockerUserTemplates: "0",
  courierTemplates: "0",
  redemptionCodeCampaign: "0",
  behavioralCampaign: "0",
  lockerCleanupTemplates: "0",
  walletTopUp: "0",
  suspiciousCourier: "0",
  suspiciousCourierNumbers: "0",
  lockerOccupancy: "0",
  lockerFullAlerts: "0",
  dropoffStatusHistory: "0",
  lockerOccupancyPeakHoursReport: "0",
  packageDropoffPeakHoursReport: "0",
  unrecognizedWaybill: "0",
  partnerPerformance: "0",
  podReports: "0",
  lockerRentals: "0",
  storageRentals: "0",
  overstayFees: "0",
  staytimeInLocker: "0",
  decliningUsage: "0",
  lockerClearingSummary: "0",
  podSummaryReport: "0",
  storageFeesSummaryReport: "0",
  overstayFeesReportSummary: "0",
  // accounting
  collectionSummary: "0",
  refundRequests: "0",
};

export const readOnlyRole = {
  lockers: "1",
  lockerFees: "1",
  lockerStorageFees: "1",
  assignToBranch: "1",
  assignToAgent: "1",
  lockerCleanUp: "1",
  reassignPackages: "1",
  lockerUserAccounts: "1",
  lockerUserType: "1",
  viewPackageHistory: "1",
  broadcastUser: "1",
  agents: "1",
  batchUpload: "1",
  broadcastAgents: "1",
  partners: "1",
  partnerTypes: "1",
  branches: "1",
  paymentModeAndFees: "1",
  lockerTimeLimits: "1",
  storageTimeLimits: "1",
  lockerUserTemplates: "1",
  courierTemplates: "1",
  lockerCleanupTemplates: "1",
  walletTopUp: "1",
  suspiciousCourier: "1",
  unrecognizedWaybill: "0",
  lockerOccupancy: "1",
  lockerFullAlerts: "1",
  dropoffStatusHistory: "1",
  lockerOccupancyPeakHoursReport: "1",
  packageDropoffPeakHoursReport: "1",
  partnerPerformance: "1",
  podReports: "1",
  lockerRentals: "1",
  storageRentals: "1",
  staytimeInLocker: "1",
  behavioralCampaign: "1",
  redemptionCode: "1",
  suspiciousCourierOPReport: "1",
  suspiciousNumbers: "1",
  unrecognizedWaybillOPReport: "1",
  decliningUsageReport: "1",
  lockerClearingSummary: "1",
  // accounting
  collectionSummary: "1",
  refundRequests: "1",
};

export const readAndWriteRole = {
  lockers: "2",
  lockerFees: "2",
  lockerStorageFees: "2",
  assignToBranch: "2",
  assignToAgent: "2",
  lockerCleanUp: "2",
  reassignPackages: "2",
  lockerUserAccounts: "2",
  lockerUserType: "2",
  viewPackageHistory: "2",
  broadcastUser: "2",
  agents: "2",
  batchUpload: "2",
  broadcastAgents: "2",
  partners: "2",
  partnerTypes: "2",
  branches: "2",
  paymentModeAndFees: "2",
  lockerTimeLimits: "2",
  storageTimeLimits: "2",
  lockerUserTemplates: "2",
  courierTemplates: "2",
  lockerCleanupTemplates: "2",
  walletTopUp: "2",
  suspiciousCourier: "2",
  unrecognizedWaybill: "0",
  lockerOccupancy: "2",
  lockerFullAlerts: "2",
  dropoffStatusHistory: "2",
  lockerOccupancyPeakHoursReport: "2",
  packageDropoffPeakHoursReport: "2",
  partnerPerformance: "2",
  podReports: "2",
  lockerRentals: "2",
  storageRentals: "2",
  staytimeInLocker: "2",
  behavioralCampaign: "2",
  redemptionCode: "2",
  suspiciousCourierOPReport: "2",
  suspiciousNumbers: "2",
  unrecognizedWaybillOPReport: "2",
  decliningUsageReport: "2",
  lockerClearingSummary: "2",
  // accounting
  collectionSummary: "2",
  refundRequests: "2",
};
